const FlatCard = ({
  children,
  customStyle,
}: {
  children: React.ReactNode
  customStyle?: string
}) => {
  return (
    <div
      className={`rounded-lg border bg-card text-card-foreground shadow-sm p-4 ${customStyle}`}
    >
      {children}
    </div>
  )
}

export default FlatCard
